// File: src/services/pin.service.ts
import api from './api';

interface PinResetResponse {
  success: boolean;
  message: string;
  extension: string;
  email_sent: boolean;
}

class PinService {
  async resetVoicemailPin(extension: string): Promise<PinResetResponse> {
    const response = await api.post('/endpoints/reset_pin', {
      extension,
      type: 'voicemail'
    });
    return response.data;
  }

  async resetSoftphonePin(extension: string): Promise<PinResetResponse> {
    const response = await api.post('/endpoints/reset_pin', {
      extension,
      type: 'softphone'
    });
    return response.data;
  }
}

const pinService = new PinService();
export default pinService;